import { useSiteTheme } from "./SiteThemeContext";

export function useSiteColors() {
  const { siteTheme } = useSiteTheme();
  const isLight = siteTheme === "light";
  return {
    bg:       isLight ? "#ffffff" : "#000000",
    fg:       isLight ? "#0a0a0a" : "#f0ede8",
    muted:    isLight ? "rgba(10,10,10,0.45)" : "rgba(240,237,232,0.4)",
    border:   isLight ? "rgba(10,10,10,0.1)" : "#1a1a1a",
    surface:  isLight ? "#f5f5f5" : "#0a0a0a",
    isLight,
  };
}
